import { IconPlus, IconSidebar } from 'featherico';
import Button from '../../react/components/Button';
import NotificationsTrigger from '../../react/components/Notifications/NotificationsTrigger/withProvider';
import GlobalCreate from '../../react/features/AppHeader/components/GlobalCreate';
import HelpMenu from '../../react/features/AppHeader/components/HelpMenu';
import UserMenu from '../../react/features/AppHeader/components/UserMenu';
import HeaderSearchBar from '../../react/features/HeaderSearchBar/container';
import { JustLaunchedBubble } from '../../react/features/JustLaunched';
import { NavItemButton } from '../../react/features/Navigation/Item';
import { useAppContext } from '../../react/hooks/useAppContext';
import { isFeatureEnabled } from '../../react/services/Features';
import type { NavStyle } from '../AppShell/useNavStyle';
import styles from './style.m.less';

type Props = {
    onCollapse: () => void;
    navStyle: NavStyle;
};

export default function Actions({ onCollapse, navStyle }: Props) {
    const { user } = useAppContext();

    return (
        <div className={styles.container}>
            <JustLaunchedBubble />

            <div className={styles.actions}>
                {!user.isGuest && (
                    <>
                        <GlobalCreate
                            trigger={
                                <Button kind="PLAIN" aria-label="Create">
                                    <IconPlus />
                                </Button>
                            }
                            user={user}
                            placement="top-start"
                        />
                        <HeaderSearchBar />
                    </>
                )}
                <HelpMenu />
                <NotificationsTrigger />
            </div>

            {isFeatureEnabled('FEATURE_navigationCompact') && navStyle === 'wide' ? (
                <div className={styles.userMenuWrapper}>
                    <UserMenu user={user} navStyle={navStyle} />
                    <NavItemButton icon={<IconSidebar />} label="Collapse Navigation" compact onClick={onCollapse} />
                </div>
            ) : (
                <UserMenu user={user} navStyle={navStyle} />
            )}
        </div>
    );
}
